import type { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { navigationLegacyDefaultV0Schema } from './default';

export type LegacyNavigation = z.infer<typeof navigationLegacyDefaultV0Schema>;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet). Single
 * placement, like indent/logo — no envelope union.
 */
export const LegacyNavigationEntitySchema = createLegacyEntitySchema([
    { name: 'web', schema: navigationLegacyDefaultV0Schema },
]);
